import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
const RequestCard = ({ title, details }) => {
  const splitEntries = chunkArray(Object.entries(details), 5); // Diviser les paires clé-valeur en groupes de 2

  return (
    <>
      <Card className="mb-4">
        <CardTitle tag="h5" style={{ paddingLeft: "10px", paddingTop: 10 }}>
          {title}
        </CardTitle>

        <CardBody>
          {splitEntries.map((pair, rowIndex) => (
            <Row key={rowIndex}>
              {pair.map(([key, value], colIndex) => (
                <>
                  <Col sm="3" key={colIndex}>
                    <p className="mb-2">
                      <i style={{ color: "#9d9c9c" }}>
                        <span
                          style={{
                            width: "auto",
                            whiteSpace: "balance",
                          }}
                        >
                          {key} :
                        </span>
                      </i>{" "}
                    </p>
                  </Col>
                  <Col sm="8" key={colIndex + 1}>
                    <span
                      style={{
                        whiteSpace: "balance",
                        fontFamily: "sans-serif",
                      }}
                    >
                      {" "}
                      {key == "URL du bug" ? (
                        <>
                          <span dangerouslySetInnerHTML={{ __html: value }} />
                        </>
                      ) : key == "Description" ? (
                        <span
                          style={{
                            width: "auto",
                            whiteSpace: "balance",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: value.replace(/\r\n/g, "<br/>"),
                          }}
                        ></span>
                      ) : key == "Pièce jointe" && value != null ? (
                        <a href={value} download>
                          <i
                            style={{
                              fontSize: "15px",
                              paddingLeft: "8px",
                              textalign: "center",
                              verticalalign: "middle",
                            }}
                            className="bx bx-download"
                          ></i>
                        </a>
                      ) : (
                        renderValue(value)
                      )}
                    </span>
                  </Col>
                </>
              ))}
            </Row>
          ))}
        </CardBody>
      </Card>
    </>
  );
};
const chunkArray = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );
};
const badgeStyle = { fontSize: "100%" };
const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé") {
    return (
      <span className="bg-success badge bg-secondary" style={badgeStyle}>
        {value}
      </span>
    );
  } else if (value === "En attente" || value === "Moyen") {
    return (
      <span className="bg-info badge bg-secondary" style={badgeStyle}>
        {value}
      </span>
    );
  } else if (value === "Élevé") {
    return (
      <span className="bg-danger badge bg-secondary" style={badgeStyle}>
        {value}
      </span>
    );
  } else if (value === "Faible") {
    return (
      <span className="bg-warning badge bg-secondary" style={badgeStyle}>
        {value}
      </span>
    );
  } else {
    return value;
  }
};
export default RequestCard;
